import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { Button, Typography } from '@speeki/global-ui-components';

import { maxWidth } from '@utils/helpers';

/** Height of the sticky site header — the chat panel is kept clear of it. */
export const SITE_HEADER_HEIGHT = 70;

export const HeaderWrapper = styled.nav(
    ({ theme: { palette } }) => css`
        align-items: center;
        background-color: ${palette.neutral.white};
        display: flex;
        justify-content: space-between;
        left: 0;
        height: ${SITE_HEADER_HEIGHT}px;
        padding: 0 48px;
        position: sticky;
        top: 0;
        width: 100%;
        z-index: 999;

        ${maxWidth('lg')} {
            padding: 0 24px;
        }

        ${maxWidth('sm')} {
            padding: 0 16px;
        }
    `,
);

export const SubsidiaryAndLogoWrapper = styled.div`
    align-items: center;
    display: flex;
    gap: 24px;
`;

export const CurrentSubsidiary = styled(Typography.TextBody_14_20)(
    ({ theme: { palette } }) => css`
        color: ${palette.text.secondary};
    `,
);

export const MobileCurrentSubsidiary = styled(Typography.TextBody_12_16)(
    ({ theme: { palette } }) => css`
        color: ${palette.text.secondary};
    `,
);

export const LoginActionsWrapper = styled.div`
    align-items: center;
    display: flex;
    gap: 28px;
`;

export const LoginLink = styled(Link)`
    text-decoration: none;
`;

export const GetStartedButton = styled(Button)`
    min-width: 180px;
`;

export const MobileLogoWrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const DivPlaceholder = styled.div`
    width: 55px;
`;

// Skeletons

export const SkeletonHeaderWrapper = styled(HeaderWrapper)`
    padding-top: 16px;
`;
